module.exports = __webpack_public_path__ + "img/chat.2927142c.png";